'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import PreviewIframe from 'ContentComponents/components/preview/PreviewIframe';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIDeviceFrame from 'UIComponents/device/UIDeviceFrame';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PreviewDevices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileLoaded: false,
      desktopLoaded: false
    };
    this.onLoad = this.onLoad.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
    this.renderPreviewComponent = this.renderPreviewComponent.bind(this);
  }
  componentDidUpdate(prevProps) {
    const {
      customPreview,
      previewUrl,
      previewHTMLOutput,
      shouldUseHTMLPreview
    } = this.props;
    const isPreviewUrlDifferent = prevProps.previewUrl !== previewUrl;
    const switchedToIframePreview = !customPreview && prevProps.customPreview;
    const showPreviewHTMLOutputLoading = !previewHTMLOutput && shouldUseHTMLPreview;
    if (!customPreview && isPreviewUrlDifferent && showPreviewHTMLOutputLoading || switchedToIframePreview) {
      this.setState({
        mobileLoaded: false,
        desktopLoaded: false
      });
    }
  }
  onLoad(type) {
    return () => {
      this.setState({
        [`${type}Loaded`]: true
      });
    };
  }
  renderLoading() {
    if (this.props.isLoading || !this.props.customPreview && !(this.state.mobileLoaded && this.state.desktopLoaded)) {
      return /*#__PURE__*/_jsx(UILoadingOverlay, {
        className: "preview-container-loading",
        contextual: true
      });
    }
    return null;
  }
  renderPreviewComponent(type) {
    const {
      from,
      previewSubject,
      subject,
      previewUrl,
      previewHTMLOutput,
      shouldUseHTMLPreview,
      selectedContact,
      contentType,
      customPreview,
      uniqueFrameId
    } = this.props;
    const renderedSubject = previewSubject || subject;
    return /*#__PURE__*/_jsx(PreviewIframe, {
      to: selectedContact,
      from: from,
      subject: renderedSubject,
      previewUrl: previewUrl,
      previewHTMLOutput: previewHTMLOutput,
      shouldUseHTMLPreview: shouldUseHTMLPreview,
      contentType: contentType,
      type: type,
      onLoad: this.onLoad(type),
      uniqueFrameId: uniqueFrameId,
      customPreview: customPreview
    });
  }
  render() {
    const showArrows = this.props.rightArrowEnabled || this.props.leftArrowEnabled;
    return /*#__PURE__*/_jsx("div", {
      id: "preview-devices",
      "data-selenium": "preview-devices",
      children: /*#__PURE__*/_jsx("div", {
        className: "preview-devices",
        children: /*#__PURE__*/_jsxs(UIFlex, {
          justify: "center",
          wrap: "nowrap",
          align: "start",
          children: [showArrows && /*#__PURE__*/_jsx(UIFlex, {
            justify: "center",
            wrap: "nowrap",
            align: "center",
            className: "preview-device-arrow-container",
            children: /*#__PURE__*/_jsx(UIIconButton, {
              onClick: this.props.onPrevious,
              className: "preview-arrow",
              disabled: !this.props.leftArrowEnabled,
              children: /*#__PURE__*/_jsx(UIIcon, {
                name: "left"
              })
            })
          }), /*#__PURE__*/_jsxs(UIFlex, {
            justify: "center",
            wrap: "wrap",
            align: "center",
            children: [/*#__PURE__*/_jsxs(UIDeviceFrame, {
              "data-test-id": "desktop-device-frame",
              contentClassName: "device-content",
              className: "device-preview desktop-preview m-y-2",
              children: [this.renderLoading(), this.renderPreviewComponent('desktop')]
            }), /*#__PURE__*/_jsxs(UIDeviceFrame, {
              "data-test-id": "mobile-device-frame",
              contentClassName: "device-content",
              type: "mobile",
              className: "device-preview mobile-preview m-y-2",
              children: [this.renderLoading(), this.renderPreviewComponent('mobile')]
            })]
          }), showArrows && /*#__PURE__*/_jsx(UIFlex, {
            justify: "center",
            wrap: "nowrap",
            align: "center",
            className: "preview-device-arrow-container",
            children: /*#__PURE__*/_jsx(UIIconButton, {
              onClick: this.props.onNext,
              style: {
                marginLeft: '34px'
              },
              className: "preview-arrow",
              disabled: !this.props.rightArrowEnabled,
              children: /*#__PURE__*/_jsx(UIIcon, {
                name: "right"
              })
            })
          })]
        })
      })
    });
  }
}
PreviewDevices.propTypes = {
  previewUrl: PropTypes.string.isRequired,
  previewHTMLOutput: PropTypes.string,
  selectedContact: PropTypes.shape({
    email: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  from: PropTypes.shape({
    email: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  subject: PropTypes.string,
  uniqueFrameId: PropTypes.string,
  shouldUseHTMLPreview: PropTypes.bool,
  previewSubject: PropTypes.string,
  isLoading: PropTypes.bool,
  contentType: PropTypes.string.isRequired,
  leftArrowEnabled: PropTypes.bool,
  rightArrowEnabled: PropTypes.bool,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  customPreview: PropTypes.object
};
PreviewDevices.defaultProps = {
  from: null,
  subject: '',
  selectedContact: null,
  isLoading: false,
  leftArrowEnabled: false,
  rightArrowEnabled: false,
  customPreview: null
};
export default PreviewDevices;